import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M46.1416 71.6399C46.1516 71.6399 46.1516 71.6399 46.1416 71.6399V71.6399Z"
        fill={`url(#${randomGradientId1})`}
        stroke="#D3D3D3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.8011 58.71C86.7611 51.97 85.2311 48.81 82.9911 46.43C79.3611 42.58 60.161 33.33 56.751 29.35C52.251 24.09 52.451 1.44995 52.451 1.44995H40.031C40.031 1.44995 40.341 24.2 35.731 29.35C31.561 34 11.891 43.13 8.69104 46.9799C6.63104 49.47 5.48104 52.47 4.50104 58.71C2.84104 69.31 2.58105 71.64 2.58105 71.64H89.731C89.721 71.64 89.4311 69.27 87.8011 58.71Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M71.9616 38.8301C71.9616 38.8301 64.3916 52.7001 45.8516 52.7001C27.3116 52.7001 20.9316 38.8301 20.9316 38.8301L12.8916 42.6301L18.2816 71.6401H73.4416L79.3816 43.2901L71.9616 38.8301Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.2912 71.8599C18.2912 71.8599 13.4112 69.0599 11.9112 65.7499C10.2612 62.1199 12.6812 58.1499 9.27118 55.2899C7.24118 53.5899 1.45117 51.8799 1.45117 46.2599L12.9012 42.6299L18.2912 71.8599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M73.4512 71.8598C73.4512 71.8598 78.8812 69.7198 80.3912 66.4098C82.0412 62.7798 79.6212 58.8098 83.0312 55.9498C85.0612 54.2498 90.8512 52.5398 90.8512 46.9198L79.4012 43.2898L73.4512 71.8598Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="46.1466"
          y1="37.5128"
          x2="46.1466"
          y2="2.77725"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
